import { getOfferProduct, sendAnalytics } from 'shared/utils/analytics';

interface ITrackFavoritesChangeParams {
  offerId: number;
  position: number;
  label: string;
  houseId: number;
  isAdded: boolean;
  isMobile?: boolean;
}

export const trackFavoritesChange = ({
  label,
  offerId,
  position,
  houseId,
  isAdded,
  isMobile,
}: ITrackFavoritesChangeParams) => {
  sendAnalytics({
    category: 'favorite',
    action: getActionByDevice(isAdded, isMobile),
    label,
    products: [getOfferProduct(offerId, position)],
    page: {
      extra: {
        houseId,
      },
    },
  });
};

function getActionByDevice(isAdded: boolean, isMobile?: boolean) {
  switch (true) {
    case isAdded && isMobile:
      return 'add_from_list_mob';
    case isAdded && !isMobile:
      return 'add_from_newlist';
    case !isAdded && isMobile:
      return 'remove_from_list_mob';
    case !isAdded && !isMobile:
      return 'remove_from_newlist';
    default:
      return '';
  }
}
